import FavoritesList from 'pages/shared/FavoritesList'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'
import useFavorites from 'hooks/useFavorites'

import { LoadingSinglePanePage, PageTitle, SinglePanePage } from 'styles/shared'

const Favorites = () => {
  const { session: { userId } } = useSessionContext()

  const { favorites, areFavoritesLoaded } = useStoreContext()

  useFavorites(userId)

  if (!areFavoritesLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <SinglePanePage>
      <PageTitle>FAVORITES</PageTitle>

      <FavoritesList {...{ favorites }} />
    </SinglePanePage>
  )
}

export default Favorites
